<template>
    <div>
        <el-tabs class="base-tabs" type="border-card">
            <el-tab-pane label="维修任务">
                <div class="lonTree-div">
                    <taskCom />
                </div>
            </el-tab-pane>
            <el-tab-pane label="通信数据">
                <div class="lonTree-div">
                    <communicationCom />
                </div>
            </el-tab-pane>
            <el-tab-pane label="器材使用记录">
                <div class="lonTree-div">
                    <usageRecordCom />
                </div>
            </el-tab-pane>
            <el-tab-pane label="数据统计">
                <div class="lonTree-div">
                    <dataStatisticCom />
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import task from "./task/index.vue"
import communication from "./communication/index.vue"
import usageRecord from "./usageRecord/index.vue"
import dataStatistic from "./dataStatistic/index.vue"
export default {
    components: {
        taskCom: task,
        communicationCom: communication,
        usageRecordCom: usageRecord,
        dataStatisticCom:dataStatistic
    },

    data() {
        return {

        };
    },

    mounted() {

    },

    methods: {

    },
};
</script>

<style lang="scss" scoped>
.lonTree-div {
    height: 640px;
    position: relative;
    z-index: 9;
    overflow-y: auto;
}
</style>